import React from "react";
import Stack from "@mui/material/Stack";
import EventIcon from '@mui/icons-material/Event';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { colors } from "../Styles";

export const CalendarLegend = () => (
  <Stack
    mt={2}
    sx={{
      "div": {
        display: "flex",
        mb: 1,
        "& > svg": {
          mr: 1,
        },
      }
    }}
  >
    <div>
      <EventIcon sx={{ color: colors.primary.dark }} />Agenda parcialmente reservada
    </div>
    <div>
      <EventBusyIcon sx={{ color: colors.red.dark }} />Agenda cheia
    </div>
  </Stack>
)
